import React from 'react';
import './App.less';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './components/global/PrivateRoute'
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import Dashboard from './pages/Dashboard/Dashboard';
import SignIn from './pages/SignIn';
import Register from './pages/Register';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import TagManager from 'react-gtm-module'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const tagManagerArgs = {
  gtmId: 'GTM-K4N38N6'
}
TagManager.initialize(tagManagerArgs)

function App() {
	return (
    <Elements stripe={stripePromise}>
    <div className="App">
		<Router>
			<Switch>
				<Route path="/signin" component={SignIn} />
				<Route path="/register" component={Register} />
				<Route path="/forgot-password" component={ForgotPassword} />
				<Route path="/reset-password" component={ResetPassword} />
				<Route path="/" component={Dashboard}/> 
				<Route component={NotFound}/>
			</Switch>
		</Router>
    </div>
    </Elements>
  );
}

export default App;
